export enum StatusPillType {
  grey,
  green,
  red,
  yellow,
  blue,
  neutral,
  error,
  purple,
  forbidden,
  lightGrey,
}
